import React from "react";
import { TbShieldCheck } from "react-icons/tb";
import { MdLocationPin } from "react-icons/md";
import { IoMdPerson } from "react-icons/io";
import { renderPrice } from "../../Utils/functions";
import { Link } from "react-router-dom";

const card = ({ data }) => {
  return (
    <Link to={"/list/" + data.slug} className="col-4">
      <div className="card-product ">
        <div className="information">
          <img
            className="image"
            src={data?.main_image?.url || require("../../assets/images/ads.png")}
          />
          <div className="explanation">
            <div className="title-product">
              <p className="">{data.title}</p>
            </div>
            <div className="details">
              {data?.options[0]?.id == 1 &&
                <div className="textPlace " data-type="verified">
                  <TbShieldCheck className="icon  textcolor" />
                  <p className="text textcolor">اگهی تایید شده</p>
                </div>
              }
              <div className="textPlace">
                <MdLocationPin className="icon  textColor" />
                <p className="text  textColor">{data?.city?.title}</p>
              </div>
              <div className="textPlace">
                <IoMdPerson className="icon  textColor" />
                <p className="text  textColor">{data?.contacts_data?.fullname || data?.contacts_data?.co_name || data?.client?.fullname}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="cardBottom">
          <p className=""> قیمت: {renderPrice(data.price)}</p>
        </div>
      </div>
    </Link>
  );
};

export default card;
